import React from "react"
import {
  BookOpen,
  Bot,
  Command,
  Frame,
  LifeBuoy,
  Map,
  PieChart,
  Send,
  Settings2,
  SquareTerminal,
  Truck,
  Users,
  Shield,
  Package,
  ScanLine,
} from "lucide-react"

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from "./ui/sidebar"

// Main navigation items based on lodia-evolve structure
const data = {
  navMain: [
    {
      title: "Dashboard",
      tabId: "dashboard",
      icon: PieChart,
    },
    {
      title: "Loading",
      tabId: "truckloading",
      icon: Truck,
    },
    {
      title: "Loader",
      tabId: "loader",
      icon: Shield,
    },
    {
      title: "Driver Management",
      tabId: "users",
      icon: Users,
    },
    {
      title: "Fleet Management",
      tabId: "products",
      icon: Package,
    },
    {
      title: "Feedback",
      tabId: "feedback",
      icon: Map,
    },
  ],
  projects: [
    {
      name: "Pallet Scanner",
      url: "/pallet-scanner",
      icon: ScanLine,
    },
    {
      name: "Pallet Classification AI",
      url: "/pallet-classification",
      icon: Frame,
    },
    {
      name: "Route Planning",
      url: "/route-planning",
      icon: Map,
    },
  ],
}

export function AppSidebar({ onTabChange, activeTab, ...props }) {
  return (
  <Sidebar
      variant="inset"
      collapsible="icon"
      // Force a professional dark-blue theme for the sidebar
      className="
        [&_[data-sidebar=sidebar]]:bg-[hsl(221_39%_16%)]
        [&_[data-sidebar=sidebar]]:text-[hsl(210_40%_98%)]
        [&_[data-sidebar=separator]]:bg-[hsl(221_39%_24%)]
        [&_[data-sidebar=group-label]]:text-[hsl(210_40%_98%)/0.7]
        [&_[data-sidebar=menu-button]]:text-[hsl(210_40%_98%)]
        [&_[data-sidebar=menu-button]]:hover:bg-[hsl(221_39%_22%)]
        [&_[data-sidebar=menu-button]]:hover:text-[hsl(210_40%_98%)]
        [&_[data-sidebar=menu-button][data-active=true]]:bg-[hsl(221_39%_22%)]
        [&_[data-sidebar=menu-button][data-active=true]]:text-[hsl(210_40%_98%)]
      "
      {...props}
    >
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton size="lg" asChild>
              <a href="#">
                <div className="flex aspect-square size-8 items-center justify-center rounded-lg bg-sidebar-primary text-sidebar-primary-foreground">
                  <Command className="size-4" />
                </div>
        <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
                  <span className="truncate font-semibold">Lodia</span>
                  <span className="truncate text-xs">Logistics Platform</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupLabel>Platform</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {data.navMain.map((item) => (
                <SidebarMenuItem key={item.title}>
          <SidebarMenuButton 
                    asChild 
                    isActive={activeTab === item.tabId}
                    tooltip={item.title}
                  >
                    <button onClick={() => onTabChange(item.tabId)}>
                      <item.icon />
            <span className="group-data-[collapsible=icon]:hidden">{item.title}</span>
                    </button>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
        
        <SidebarSeparator />
        
        <SidebarGroup>
          <SidebarGroupLabel>Operations</SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarMenu>
              {data.projects.map((item) => {
                const isPalletScanner = item.url === '/pallet-scanner';
                const isPalletAI = item.url === '/pallet-classification';
                const isComingSoon = item.url === '/route-planning';
                const tabId = isPalletScanner ? 'pallet-scanner' : (isPalletAI ? 'pallet-classification' : (isComingSoon ? 'coming-route' : null));
                return (
                  <SidebarMenuItem key={item.name}>
                    <SidebarMenuButton asChild tooltip={item.name} data-active={activeTab === tabId}>
                      <button onClick={() => onTabChange(tabId)}>
                        <item.icon />
                        <span className="group-data-[collapsible=icon]:hidden">{item.name}{isComingSoon && ' (Soon)'}</span>
                      </button>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      
      <SidebarFooter>
        <SidebarMenu>
          <SidebarMenuItem>
      <SidebarMenuButton size="lg" asChild>
              <a href="/settings">
                <Settings2 />
        <div className="grid flex-1 text-left text-sm leading-tight group-data-[collapsible=icon]:hidden">
                  <span className="truncate font-semibold">Settings</span>
                  <span className="truncate text-xs">Manage preferences</span>
                </div>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarFooter>
    </Sidebar>
  )
}
